export function MainContainer({ children }: React.PropsWithChildren) {
  return (
    <main className="px-5 py-6 lg:flex-1 sm:px-10 sm:py-8 md:pt-12 lg:pr-10 xl:pl-[calc(((100vw-1440px)/2)+2rem)]">
      {children}
    </main>
  );
}
